import { SparklesIcon } from "lucide-react";
import type { CmmdProjectTaskDraftSuggestion } from "@cmmd-forge/contracts";

import { Button } from "~/components/ui/button";
import { RESPONSIVE_TEXT_BUTTON_CLASS } from "~/lib/touchTarget";

export interface ProjectLeadSuggestionsProps {
  readonly suggestions: readonly CmmdProjectTaskDraftSuggestion[];
  readonly disabled: boolean;
  readonly onResolve: (suggestionId: string, resolution: "apply" | "dismiss") => void;
}

export function ProjectLeadSuggestions(props: ProjectLeadSuggestionsProps) {
  const proposed = props.suggestions.filter((suggestion) => suggestion.status === "proposed");
  return proposed.length > 0 ? (
    <aside className="border-t border-border bg-primary/5 px-4 py-3">
      <div className="mx-auto max-w-3xl space-y-2">
        {proposed.map((suggestion) => (
          <div
            key={suggestion.id}
            className="flex flex-wrap items-center gap-[8px] rounded-lg border border-primary/25 bg-background px-3 py-3 md:py-2"
          >
            <SparklesIcon className="size-4 shrink-0 text-primary" aria-hidden />
            <p className="min-w-48 flex-1 text-sm text-foreground">{suggestion.summary}</p>
            <Button
              size="xs"
              className={RESPONSIVE_TEXT_BUTTON_CLASS}
              disabled={props.disabled}
              onClick={() => props.onResolve(suggestion.id, "apply")}
            >
              Apply
            </Button>
            <Button
              size="xs"
              variant="ghost"
              className={RESPONSIVE_TEXT_BUTTON_CLASS}
              disabled={props.disabled}
              onClick={() => props.onResolve(suggestion.id, "dismiss")}
            >
              Dismiss
            </Button>
          </div>
        ))}
      </div>
    </aside>
  ) : null;
}
